module.exports = __webpack_public_path__ + "static/media/sidebarmenuliveproject.491742a7.png";